/*  Copyright (C) 2025, 2026  Paul B. Lucas   ALL RIGHTS RESERVED
    Licensed to University of Illinois   
*/
//
//  This is the authentication configuration for the Equipment-Loan-Application-Manager Vue3 Web-app
//  hosted on a F&S tenant.  Client IDs and redirectURIs are for development:
//      clientId: 'abc668df-028f-48e3-80f3-c32f9e99cd24',
//      redirectUri: 'https://loanapp.eqloan.northcentralus.cloudapp.azure.com'
//      Campus DNS: https://loanapp.elam.fs.illinois.edu
//
//  Description:
//      This package implements OAuth2.0 'authorization code flow with PKCE' using a redirect auth method
//      Redirects are required since SSO authentication is provided by a common University Login page (with 2FA)
//      Admin groups are obtained from the claims token.  These are set on the RWA app registration via the Enterprise 
//      Application tab from the App Registration Overview.  Only the configured groups are returned on the claim.
//      In addition, several AD attributes such as UIN are returned as optional claims. (These need to be added by an
//      IAMU administrator). These optional claims include UIN which is used as a key for Banner requests.
//
//      Alternativly, the useGraphAPI is setup to obtain all user groups on a graph request.  This was used previously
//      to obtain groups which were filtered for applicable admin groups for this application.    Use of graph for this
//      purpose is now deprecated.
//
//      Graph is used to set and removed users from admin groups (function available from Settings View).
//
//      The graphAPI (separate package - usegraphAPI.js) requires the delegated user token in order to obtain or 
//      manipulate groups.
//
//      RedirectRequest is a class in the @azure/masl-broswer package.  The handleRedirectPromise() method is a 
//      member of the RedirectRequest.   This process handles the retrieval of the authorization code, the generation of the
//      code_verifier, code_challenge, state generation, and nonce generation used to claim the authentication token
//      which is returned on the Authentication Account (which includes the enumerated claims and actual token).
//
//      The first return from the login redirect (or token cache) is on the URL specified in the Entra App registration and in 
//      msalConfig.ts (must match).  The redirect URL is affixed with either a hash or query string providing authoriation code.
//      the hash mode is default.
//
//              <redirect url>/#code=0.<some base64 encoded string>
//
//      This code is subsequently stripped from the redirect URL on the second pass to the handleRedirectPromise() so that the 
//      code does not show on the user's browser address window.  The msal-browser library handles all of the access token 
//      retrieval work as part of the handleredirectPromise call.  The user idToken is obtained directly and the accessToken is
//      obtained as user.accessToken.
//
//      The user token (idToken) returned from the activeAccount is not the access token for graphAPI use as the audience is
//      wrong.  An additional token is required for API use with the scope and audiences set for Microsoft Graph.
//
//      The audience needs to be "aud": "00000003-0000-0000-c000-000000000000"
//
//      WARNINGS:
//
//          1. idTokens or accessTokens should not be stored in local browser storage (store state, code_validator, and nonce instead)
//             (State inhibits cross-site hijacking, nonce inhibits replay)   
//
//    
//  Revisions:
//     02/25/2025       pblucas     Changed ClientID to 'Equipment-Loan-Application-Manager'
//      



import { PublicClientApplication, AccountInfo, RedirectRequest, LogLevel  } from '@azure/msal-browser'
import {reactive}   from 'vue'


export const msalConfig = {
    auth: {
        clientId: 'abc668df-028f-48e3-80f3-c32f9e99cd24',
        authority: 'https://login.microsoftonline.com/44467e6f-462c-4ea2-823f-7800de5434e3',
        redirectUri: 'https://loanapp.eqlm.fs.illinois.edu',
        postLogoutUri: 'https://loanapp.eqlm.fs.illinois.edu'
        //redirectUri: 'http://localhost:8080',
        //postLogoutUri: 'http://localhost:8080'
   },
    cache: {
        cacheLocation: 'sessionStorage', // cache storage location
        storeAuthStateInCookie: false
    },
    
    // Uncomment this section to provide for verbose troubleshooting of the authentication process
    /*
    system: {
        loggerOptions: {
            logLevel: LogLevel.Trace,
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.log(message);
                        return;
                }
            }
        }
    },
    */
}

export const graphScopes: RedirectRequest = {
    scopes: ['user.read', 'openid', 'profile', 'groupMember.Read.All', 'groupMember.ReadWrite.All']
} 

export const graphRequestScopes = {
    scopes: ["User.Read", "GroupMember.Read.All", "GroupMember.ReadWrite.All"],
};

export const authState = reactive({
    user: null as AccountInfo | null
})
//console.log("msalConfig:: exported state: "+JSON.stringify(state))

export const myMSALObj = new PublicClientApplication(msalConfig)



    
